import React from "react";
import { Card, Table, Typography, Tag } from "antd";
import { CheckSquareFilled, CloseOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const RolePermissions = () => {
    const columns = [
        {
            title: "Quyền hạn",
            dataIndex: "permission",
            key: "permission",
            width: "35%",
            render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
        },
        {
            title: "Agent",
            dataIndex: "agent",
            key: "agent",
            align: "center",
            render: (val) => renderStatus(val),
        },
        {
            title: "Team leader",
            dataIndex: "teamLeader",
            key: "teamLeader",
            align: "center",
            render: (val) => renderStatus(val),
        },
        {
            title: "QA",
            dataIndex: "qa",
            key: "qa",
            align: "center",
            render: (val) => renderStatus(val),
        },
        {
            title: "Local Admin",
            dataIndex: "localAdmin",
            key: "localAdmin",
            align: "center",
            render: (val) => renderStatus(val),
        },
        {
            title: "System Admin",
            dataIndex: "systemAdmin",
            key: "systemAdmin",
            align: "center",
            render: (val) => renderStatus(val),
        },
    ];

    const renderStatus = (val) => {
        if (val) {
            return (
                <span style={{ fontSize: "20px", color: "#52c41a" }} title="Có quyền">
                    ✅
                </span>
            );
        }
        return (
            <span style={{ fontSize: "18px", color: "#ff4d4f" }} title="Không có quyền">
                ❌
            </span>
        );
    };

    const dataSource = [
        { key: "1", permission: "Nhận inbound call", agent: true, teamLeader: true, qa: false, localAdmin: true, systemAdmin: true },
        { key: "2", permission: "Thực hiện outbound call", agent: true, teamLeader: true, qa: false, localAdmin: true, systemAdmin: true },
        { key: "3", permission: "Hold / Transfer / Conference", agent: true, teamLeader: true, qa: false, localAdmin: true, systemAdmin: true },
        { key: "4", permission: "Thay đổi trạng thái (Ready, Break, Lunch...)", agent: true, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "5", permission: "Xem trạng thái của bản thân & của nhóm mình", agent: true, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "6", permission: "Xem log cuộc gọi cá nhân & của nhóm mình", agent: true, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "7", permission: "Nghe recording của bản thân & của nhóm mình", agent: true, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "8", permission: "Download recording của bản thân & của nhóm mình", agent: true, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "9", permission: "Dashboard & Reporting của bản thân", agent: true, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "10", permission: "Dashboard & Reporting của nhóm", agent: false, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        { key: "11", permission: "Export dữ liệu", agent: false, teamLeader: true, qa: true, localAdmin: true, systemAdmin: true },
        {
            key: "12",
            permission: "Quản lý user (enable/disable account, callout, view call log, view agent status, update account information)",
            agent: false,
            teamLeader: false,
            qa: false,
            localAdmin: true,
            systemAdmin: true,
        },
        { key: "13", permission: "Quản lý IVR / Routing", agent: false, teamLeader: false, qa: false, localAdmin: false, systemAdmin: true },
        { key: "14", permission: "Cấu hình hệ thống", agent: false, teamLeader: false, qa: false, localAdmin: false, systemAdmin: true },
    ];

    return (
        <div style={{ padding: "16px", background: "#f0f2f5", minHeight: "100%" }}>
            <Card
                title={<Title level={4} style={{ margin: 0 }}>Bảng phân quyền người dùng</Title>}
                bordered={false}
                style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
            >
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    bordered
                    size="middle"
                    rowClassName={(record, index) => (index % 2 === 0 ? "table-row-light" : "table-row-white")}
                />
            </Card>
        </div>
    );
};

export default RolePermissions;
